import { fromJS } from 'immutable';

export function request(state) {
    return state.set('nyxGames', fromJS({
        status: 'IN_PROGRESS'
    }));
}

export function finish(state, { nyxGames }) {
    return state.set('nyxGames', fromJS({
        status: 'FINISHED',
        items: nyxGames
    }));
}

export function error(state) {
    return state.set('nyxGames', fromJS({
        status: 'ERROR'
    }));
}
